module.exports = __webpack_public_path__ + "assets/img/2.becc490b.png";